// Shared

export const PARAM_PROVIDER_ID = 'providerId';
export const PARAM_CATEGORY_ID = 'categoryId';
export const PARAM_BONUS_ID = 'bonusId';
export const PARAM_CAMPAIGN_ID = 'campaignId';
export const PARAM_GAME_ID = 'gameId';
export const PARAM_ERROR_STATUS = 'status';
export const PARAM_PAGE_NUMBER = 'page';

export const PAGINATION_TEMPLATE = `/page/:${PARAM_PAGE_NUMBER}?`;

// Route templates

export const ROOT = '/';
export const SEARCH = '/search';
export const FAVORITES = '/favorites';
export const RECENT_GAMES = '/recent-games';

export const PROVIDER_LIST = '/providers';
export const PROVIDER_DETAIL = `/providers/:${PARAM_PROVIDER_ID}`;
export const PROVIDER_DETAIL_PAGINATED = `${PROVIDER_DETAIL}${PAGINATION_TEMPLATE}`;

export const CATEGORY_LIST = '/categories';
export const CATEGORY_DETAIL = `/categories/:${PARAM_CATEGORY_ID}`;
export const CATEGORY_DETAIL_PAGINATED = `${CATEGORY_DETAIL}${PAGINATION_TEMPLATE}`;

export const GAME_DETAIL = `/game/:${PARAM_GAME_ID}`;
export const DEMO_GAME_DETAIL = `/demo-game/:${PARAM_GAME_ID}`;

export const TOURNAMENTS = '/casino-tournaments';

export const BONUSES_LIST = '/bonuses';
export const BONUSES_HISTORY = '/bonuses/history';
export const BONUS_GAMES_WAGERING = '/bonuses/games/wagering';
export const BONUS_GAMES_COLLECTING = `/bonuses/games/collecting/:${PARAM_CAMPAIGN_ID}`;
export const BONUS_DETAIL = `/bonuses/bonus/:${PARAM_BONUS_ID}`;
export const CAMPAIGN_DETAIL = `/bonuses/campaign/:${PARAM_CAMPAIGN_ID}`;

export const COMMON_ERROR = `/:${PARAM_ERROR_STATUS}([4,5]\\d{2})`;
export const SERVER_ERROR = '/500';
export const NOT_FOUND = '/404';
export const UNAUTHORIZED = '/401';
export const NO_MATCH = '*';

// eslint-disable-next-line import/no-anonymous-default-export
export const ALL_ROUTES_VALUES = [
  ROOT,
  SEARCH,
  FAVORITES,
  RECENT_GAMES,
  PROVIDER_LIST,
  PROVIDER_DETAIL,
  PROVIDER_DETAIL_PAGINATED,
  CATEGORY_LIST,
  CATEGORY_DETAIL,
  CATEGORY_DETAIL_PAGINATED,
  GAME_DETAIL,
  DEMO_GAME_DETAIL,
  BONUSES_LIST,
  BONUSES_HISTORY,
  BONUS_DETAIL,
  CAMPAIGN_DETAIL,
  BONUS_GAMES_WAGERING,
  BONUS_GAMES_COLLECTING,
  COMMON_ERROR,
  NOT_FOUND,
  UNAUTHORIZED,
  SERVER_ERROR,
  NO_MATCH,
];
